import dayjs from "dayjs";
import constants from "@/config/constants";
/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
}

export function convertDateTime(timestamp, format = "ss:mm:HH DD/MM/YYYY") {
  if (!timestamp) {
    return "";
  }
  if (typeof timestamp === "number") {
    return dayjs(timestamp * 1000).format(format);
  }
  return dayjs(timestamp).format(format);
}

export function numberWithDelimiter(number, delimiter = ".") {
  return Math.round(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
}

export function getTagValue(item, data) {
  if (item.options && item.options.length > 0) {
    const option = item.options.find(
      (o) => data && (o.value || o.key) === data[item.key]
    );
    return option?.label || option?.name;
  }
  return data ? data[item.key] || item.key : item.key;
}

export function getElementDateFormat(format) {
  return format?.replace("DD", "dd").replace("YYYY", "yyyy");
}

export function formatFileSize(bytes) {
  return new Intl.NumberFormat("en", {
    style: "unit",
    unit: "byte",
    unitDisplay: "long",
    notation: "compact",
  }).format(bytes);
}

export function statusName(value, statuses) {
  const status = statuses.find((s) => s.value === value && !!s.name);
  return status?.name || status?.menu || status?.label || value
}

export function contractName(value, contracts) {
  return contracts.find((c) => c.id === value)?.name || value
}

export function categoryName(value, categories) {
  return categories.find((c) => c.id === value)?.extra?.name || value
}

export function objectCountValue(categoryId, objectType, objectCounts) {
  return objectCounts.find((c) => c.objectType === objectType && c.categoryId === categoryId)?.value || 0
}

export function avatarUrl(files = [], avatarData) {
  return avatarData.find((c) => c.id === files[0]?.id)?.url || null
}

export function moduleName(value, modules) {
  return modules.find((c) => c.key === value)?.name || value
}

export function actionName(value, actions) {
  return actions.find((c) => c.id === value)?.name || value
}

export function documentName(value, documents) {
  return documents.find((c) => c.id === value)?.extra?.name || value
}

export function accountName(value, accounts) {
  return accounts.find((c) => c.id === value)?.email || value
}

export function roleAction(value, key = 'label') {
  const action = constants.DOCUMENT_TYPE_ACTION_METHODS.find((a) => a.key === value)
  return action ? action[key] : value
}

export function configName(value, configs) {
  if (value === 'tags') {
    return 'Quản lý thẻ Tags'
  }
  const config = configs.find((c) => c.extra.key === value)
  return config?.extra?.info?.menu || config?.extra?.name || value
}
